import { createReducers, createActions, request } from 'Util';
import { combineReducers } from 'redux';
import Urls from 'Urls';
import { message } from 'antd';
import _ from 'lodash';
import moment from 'moment';

const { fileUrl } = Urls;

const path = name => `app/pages/fileList/${name}`;
const models = {
    list: {
        data: [],
        handlers: {
            get(state, action) {
                return action.payload;
            },
            add(state, action) {
                return [...action.payload, ...state];
            },
            del(state, action) {
                return state.filter(item => item._id !== action.payload);
            },
            update(state, action) {
                return state.map(item => (item._id === action.payload._id ? action.payload : item));
            },
        },
    },
    selectedContent: {
        data: [],
        handlers: {
            getSele(state, action) {
                return action.payload;
            },
        },
    },
    listAll: {
        data: [],
        handlers: {
            getAll(state, action) {
                return action.payload;
            },
        },
    },
    transferData: {
        data: {
            selectedRowKeys: [],
        },
        handlers: {
            getTransferData(state, action) {
                return { ...state, ...action.payload };
            },
        },
    },
    pagination: {
        data: {
            current: 1,
            total: 0,
            pageSize: 10,
        },
        handlers: {
            changePagination(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    searchValues: {
        data: {},
        handlers: {
            changeSearchValues(state, action) {
                return action.payload;
            },
        },
    },
    uiStatus: {
        data: {
            isLoading: false,
            isFileLoading: false,
        },
        handlers: {
            changeUiStatus(state, action) {
                return {
                    ...state,
                    ...action.payload,
                };
            },
        },
    },
    currentSelectId: {
        data: '',
        handlers: {
            changeCurrentSelectId(state, action) {
                return action.payload;
            },
        },
    },
};

export const actions = createActions(models, path);

export default combineReducers(createReducers(models, path));

const formatGetParams = getState => {
    const state = getState().fileList;
    const searchValue = state.searchValues || {};

    const params = {
        ...searchValue,
        page: state.pagination.current,
        pageSize: state.pagination.pageSize,
    };
    return params;
};

const getParams = function (params) {
    let temp = [];
    for (let key in params) {
        if (params[key]) {
            temp.push(`${key}=${params[key]}`);
        }
    }
    temp = temp.join('&');
    return temp;
};

/**
 * 获取订单列表数据
 */
export const asyncGet = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(
                actions.changeUiStatus({
                    isLoading: true,
                }),
            );
            const params = getParams(formatGetParams(getState));
            // 下面的请求和结果返回需要根据接口来实现
            let result = await request(`${fileUrl.fileList}?${params}`, 'GET');
            let { list } = result;
            dispatch(actions.get(list));
            dispatch(actions.changePagination({ total: result.total }));
        } catch (e) {
            throw e;
        } finally {
            dispatch(
                actions.changeUiStatus({
                    isLoading: false,
                }),
            );
        }
    };
};


// 删除用户
export const delect = record => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({ isLoading: true }));
            const { fileName } = record;
            // 下面的请求和结果返回需要根据接口来实现
            await request(`${fileUrl.delete}?fileName=${fileName}`, 'GET');
            message.success('删除成功');
        } catch (e) {
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({ isLoading: false }));
        }
    };
};

// 文件上传
export const asyncUpload = data => {
    return async (dispatch, getState) => {
        try {
            dispatch(actions.changeUiStatus({ isFileLoading: true }));
            let uuid = '';
            for (let i = 0; i < 32; i++) {
                uuid += Math.floor(Math.random() * 16).toString(16);
            }
            // 下面的请求和结果返回需要根据接口来实现
            await request(`${fileUrl.upload}`, 'POST', data);
            message.success('上传成功');
        } catch (e) {
            message.error('上传失败');
            throw e;
        } finally {
            dispatch(actions.changeUiStatus({ isFileLoading: false }));
        }
    };
};




// WEBPACK FOOTER //
// ./pages/fileList/reducers.js